import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
// import axios from 'axios';
import axios from '../../../../utils/axiosInstance';
import HourglassLoader from '../../../../Common/HourglassLoader';

import ReCAPTCHA from "react-google-recaptcha";
import { jwtDecode } from "jwt-decode";
import { db } from '../../../firbase';
import { doc, updateDoc } from "firebase/firestore";

const host = process.env.REACT_APP_API_SERVER;
const siteKey = process.env.REACT_APP_SITE_KEY;

const StudentLogin = () => {
    const navigate = useNavigate();
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaError, setCaptchaError] = useState("");
    const captchaRef = React.useRef(null);

    const [faIcon, setfaIcon] = useState('fa-eye-slash');
    const togglePasswordType = () => {
        let input_pass = document.getElementById('password-field');
        const toggle_pass = document.getElementById("toggle_pass");
        let input_type = input_pass.getAttribute('type');
        if (input_type == "password") {
            setfaIcon('fa-eye');
            input_pass.type = "text";
        } else {
            setfaIcon('fa-eye-slash')
            input_pass.type = "password"
        }
    }
    let [initialValues, setInitialValues] = useState({

        emailMob: "",
        password: "",
        user_type: "student"

    })

    const studentformik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            emailMob: Yup.string().required("Email is required.").matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,4}$/, "Enter a valid Email"),

            password: Yup.string().required("Password is required"),

        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                if (!captchaToken) {
                    setCaptchaError("Please complete the CAPTCHA.");
                    return;
                }
                setSubmitting(true);

                // Sending data to the API
                const response = await axios.post(`${host}/api/web/student-sign-in`, {
                    ...values,
                    captchaToken,
                });

                if (response.status === 200) {
                    setSubmitting(false);
                    toast.success("Signed In Successfully");
                    resetForm();

                    // Clear existing tokens and set the new token
                    localStorage.removeItem("tutor-token");
                    localStorage.setItem("student-token", response.data.token);
                    await axios.get(`${host}/api/web/change-online-status?status=1`, {
                        headers: {
                            "x-auth-token": localStorage.getItem('student-token')
                        }
                    });


                    // Navigate to the student dashboard
                    navigate("/student");
                } else {
                    setSubmitting(false);
                    toast.error(response.data.message);
                    if (captchaRef.current) {
                        captchaRef.current.reset(); // Reset the CAPTCHA
                    }
                    setCaptchaToken(null);
                }
            } catch (error) {
                // Handle errors
                setSubmitting(false);
                toast.error("Error submitting form. Please try again.");
                if (captchaRef.current) {
                    captchaRef.current.reset(); // Reset the CAPTCHA
                }
                setCaptchaToken(null);
            }
        }

    });

    const handleCaptcha = (token) => {
        setCaptchaToken(token);
        setCaptchaError("");
    };

    return (
        <form
            onSubmit={studentformik.handleSubmit}

            id="influencerLogin"
            method="POST"
            style={{ padding: 20 }}
        >
            {" "}
            <div className="mb-3">
                <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label"
                >
                    Email
                </label>
                <input
                    type="text"
                    placeholder="Enter Your Email"
                    className="form-control"
                    name='emailMob'
                    onChange={studentformik.handleChange}
                    onBlur={studentformik.handleBlur}
                    value={studentformik.values.emailMob}
                />
                <div className="help-block with-errors">
                    {studentformik.touched.emailMob && studentformik.errors.emailMob ? (
                        <div className='text-danger'>{studentformik.errors.emailMob}</div>
                    ) : null}
                </div>
            </div>
            <div>
                <label htmlFor="inputPass" className="form-label">
                    {" "}
                    Password
                </label>
                <div className="input-group">
                    <input
                        placeholder="Enter Your Password"
                        id="password-field"
                        type="password"
                        className="form-control"
                        name="password"
                        onChange={studentformik.handleChange}
                        onBlur={studentformik.handleBlur}
                        value={studentformik.values.password}
                    />
                    <i
                        toggle="#password-field" className={`fa-regular ${faIcon} field-icon toggle-password `} id="toggle_pass" onClick={togglePasswordType}
                    />

                </div>
                <div className="help-block with-errors">
                    {studentformik.touched.password && studentformik.errors.password ? (
                        <div className='text-danger'>{studentformik.errors.password}</div>
                    ) : null}
                </div>
            </div>
            <div className='mt-3'>
                <ReCAPTCHA
                    sitekey={siteKey}
                    onChange={handleCaptcha}
                    ref={captchaRef} // Attach the ref to the CAPTCHA
                />
                {captchaError && <div className="text-danger">{captchaError}</div>}
            </div>
            <div className="my-2 row">
                <div className="col-sm-12 mb-2 text-center">

                    <button
                        type="submit"
                        className="login-btn btn btn-primary text-white fw-bold py-2 px-0"
                        id="loderButton"
                        disabled={studentformik.isSubmitting}
                    >
                        {studentformik.isSubmitting ? <HourglassLoader /> : 'Login'}
                    </button>


                </div>
                <div className="col-lg-12">
                    <Link
                        to="/forget-password"
                        className="mb-2 d-flex justify-content-end"
                    >
                        <p
                            className="text-primary text-decoration-underline"
                            style={{ fontSize: 14 }}
                        >
                            Forgot Your Password ?
                        </p>
                    </Link>
                </div>
            </div>
            <div className="log-undre-text text-center mt-2">
                <p>
                    Not registered yet?
                    <Link
                        to="/register">
                        <span>Register</span>
                    </Link>{" "}
                </p>
            </div>
        </form>
    )
}

export default StudentLogin